"use strict";

/*********************************************************
 * Так как размер кук ограничен в 4к, сохраняем настройки,
 * доступ к ктороным не нужен на бэкенде, в локальное
 * хранилище
 */
Fotobook.userSettings = {
    _createKey: function(rawkey){
        return 's_u_0_' + rawkey;
    },
    get: function(key){
        return localStorage.getItem(this._createKey(key));
    },
    /**
     * Стоит ли делать хранилище уникальным для каждого пользователя?
     * если решим, что да - цифру 0 в ключе будем заменять на id юзера
     */
    _clearOtherUsersSettings: function(){
        return;
       /* var to_del = [],
            key, matched, i, l;
        for (i=0, l=localStorage.length; i<l; i++){
            key = localStorage.key(i);
            matched = key.match(/^s_u_(\d+)_/);
            if (matched && Fotobook.store.state.user.id != matched[1]){
                to_del.push(key);
            }
        }
        for (i=0, l=to_del.length; i<l; i++){
            localStorage.removeItem(to_del[i]);
        }*/
    },
    set: function(key, value){
        key = this._createKey(key);
        try {
            localStorage.setItem(key, value);
        } catch(e){
            if (e.code == DOMException.QUOTA_EXCEEDED_ERR){
                this._clearOtherUsersSettings();
                try {
                    localStorage.setItem(key, value);
                } catch(e) {
                }
            }
        }
    },
    remove: function(key){
        localStorage.removeItem(this._createKey(key));
    },
};
